import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import "./postventa.scss"

export const PostVentaSection = () => {
  return (
    <>
      <section
        className="servicios-postventa-container"
        data-sal="slide-up"
        data-sal-delay="200"
        data-sal-easing="ease"
      >
        <div className="servicios-postventa-info-container">
          <div className="servicios-postventa-info-text">
            <p>
              Nuestro servicio <span>post-venta </span>
              garantiza asesoramiento, supervisión y control de equipos y
              sistemas, soporte on line para la solución inmediata de dudas o
              problemas de operativa y funcionamiento, así como mantenimiento
              preventivo y correctivo in-situ en todas las instalaciones.
            </p>
          </div>
          <div className="servicios-postventa-info-image">
            <StaticImage
              src="../../../../images/servicios/postventa/post-venta-big.png"
              alt="image-servicios-postventa"
            />
          </div>
        </div>
      </section>
    </>
  )
}
